// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__DK4BL","imageUploader":"EGiftCard_imageUploader__1KPx9"};